export function sortByKeyAsc<T>(list: T[], key: keyof T): T[] {
  const isEnglish = (str: string) => /^[A-Za-z]/.test(str); // Starts with A-Z or a-z

  return [...list].sort((a, b) => {
    const aVal = a[key];
    const bVal = b[key];

    if (typeof aVal === "string" && typeof bVal === "string") {
      const aIsEng = isEnglish(aVal);
      const bIsEng = isEnglish(bVal);

      if (aIsEng && !bIsEng) return -1; // English before non-English
      if (!aIsEng && bIsEng) return 1;

      // Both are same language type – sort alphabetically
      return aVal.localeCompare(bVal, undefined, { sensitivity: 'base' });
    }

    return 0;
  });
}

export function sortByKeyAscComp<T>(list: T[], key: keyof T): T[] {
   return [...list].sort((a, b) => {
    const aVal = String(a[key] ?? "");
    const bVal = String(b[key] ?? "");

    return aVal.localeCompare(bVal, ['zh', 'ja', 'en'], { numeric: true, sensitivity: 'base' });
  });
}